import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFieldMcq = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 18 18",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M9 18A9 9 0 109 0a9 9 0 000 18zm0-1.385a7.615 7.615 0 110-15.23 7.615 7.615 0 010 15.23z" }), /* @__PURE__ */ _jsx("circle", {
		cx: 9,
		cy: 9,
		r: 5
	})]
});
export default SvgFieldMcq;
